export class Bookmark {
    constructor() {
    }

    init() {
        $(document).on('click', '.js-add-bookmark-button', (e) => this.addBookmark(e));
        $(document).on('click', '.js-remove-bookmark-button', (e) => this.removeBookmark(e));
    }

    addBookmark(e) {
        e.preventDefault();

        let $button = $('.js-add-bookmark-button');
        let pagelink = $button.attr("data-value");
        let userId = $button.attr("data-id");

        $.ajax({
            type: 'POST',
            url: '/api/account/addbookmark/',
            contentType: "application/json",
            data: JSON.stringify({ "PageLink": pagelink, "UserId": userId }),
            success: function() {
                // refresh the page if username and password are correct
                location.reload();
            },
            error: function(e1, e2) {
            }
    });
    }


    removeBookmark(e) {
        e.preventDefault();
        
        let $button = $('.js-remove-bookmark-button');
        let pagelink = $button.attr("data-value");
        let userId = $button.attr("data-id");

        $.ajax({
            type: 'POST',
            url: '/api/account/removebookmark/',
            contentType: "application/json",
            data: JSON.stringify({ "PageLink": pagelink, "UserId": userId }),
            success: function () {
                // refresh the page if username and password are correct
                location.reload();
            }
        });
    }

    setLoginErrorMessage(msg, clearFirst) {
        if (clearFirst)
            $('#login-form-errors').html("");

        if(msg)
            $('#login-form-errors').append(msg);
    }
}



// WEBPACK FOOTER //
// ./frontend/js/components/ost.bookmark.js